export class BatchDraftCommitInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "changes",
            "baseName": "changes",
            "type": "Array<CommitChangeInput>",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BatchDraftCommitInput.attributeTypeMap;
    }
    constructor() {
    }
}
